"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadStrokeColorUpdater = void 0;

var StrokeColorUpdater_1 = require("./StrokeColorUpdater");

function loadStrokeColorUpdater(tsParticles) {
  tsParticles.addParticleUpdater("strokeColor", function () {
    return new StrokeColorUpdater_1.StrokeColorUpdater();
  });
}

exports.loadStrokeColorUpdater = loadStrokeColorUpdater;